import { Link } from 'react-router-dom'
import { useAuth } from '../lib/auth'

export function UnauthorizedPage() {
  const { isAuthenticated } = useAuth()

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--space-4)',
        textAlign: 'center',
        padding: 'var(--space-8)',
      }}
    >
      <div style={{ fontSize: '4rem' }}>🚫</div>
      <h1 style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 700 }}>Acesso negado</h1>
      <p style={{ color: 'var(--color-gray-600)', maxWidth: '360px' }}>
        Seu perfil não tem permissão para acessar esta página.
        Verifique com o administrador se seu papel está correto.
      </p>
      <Link to={isAuthenticated ? '/' : '/login'} className="btn btn-primary">
        {isAuthenticated ? 'Ir para o início' : 'Fazer login'}
      </Link>
    </div>
  )
}
